module.exports = __webpack_public_path__ + "static/media/spacehologram_3.15502e60.jpg";